export default "__VITE_ASSET__Cf383S8W__"